import React from 'react'
import './line-clamp.css'

interface LineClampProps<T extends React.ElementType> {
  text?: string
  as?: T
  children?: React.ReactNode
  className?: string
}

export default function LineClamp<T extends React.ElementType = 'div'>({
  text,
  as,
  children,
  className,
  ...props
}: LineClampProps<T>) {
  const Component = as || 'div'

  return (
    <Component className={`line-clamp ${className || ''}`} {...props}>
      {text || children}
    </Component>
  )
}
